var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "full-height bg-white" },
    [
      _c("q-card-title", { staticClass: "text-center bg-primary text-white" }, [
        _vm._v("\n        " + _vm._s(_vm.$t("badges")) + "\n    ")
      ]),
      _c("q-card-separator"),
      _c(
        "q-card-main",
        { staticClass: "text-center relative-position full-height" },
        [
          _c(
            "div",
            { staticClass: "row gutter-sm" },
            _vm._l(_vm.badges, function(badge, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "badge",
                  class: _vm.home ? "col-xs-4 col-sm-2" : "col-xs-4 col-sm-1"
                },
                [
                  _c("img", {
                    staticClass: "cursor-pointer",
                    class: _vm.getBadgeClass(badge),
                    attrs: { src: _vm.getBadgeImage(badge) },
                    on: {
                      click: function($event) {
                        return _vm.showBadgeInfo(badge)
                      }
                    }
                  })
                ]
              )
            }),
            0
          ),
          _c(
            "q-inner-loading",
            { attrs: { visible: !_vm.badges } },
            [_c("q-spinner-dots", { attrs: { size: 60, color: "secondary" } })],
            1
          )
        ],
        1
      ),
      _vm.show_info
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": {
                  minWidth: _vm.getMinWidth,
                  maxWidth: _vm.getMaxWidth
                }
              },
              model: {
                value: _vm.show_info,
                callback: function($$v) {
                  _vm.show_info = $$v
                },
                expression: "show_info"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            _vm.show_info = false
                          }
                        }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.selected_badge.title) +
                            "\n                "
                        )
                      ])
                    ],
                    1
                  ),
                  _c("div", { staticClass: "layout-padding" }, [
                    _c("div", { staticClass: "row gutter-sm" }, [
                      _c("div", { staticClass: "col-xs-12 col-sm-3 badge" }, [
                        _c("img", {
                          class: _vm.getBadgeClass(_vm.selected_badge),
                          attrs: { src: _vm.getBadgeImage(_vm.selected_badge) }
                        })
                      ]),
                      _c("div", { staticClass: "col-xs-12 col-sm-9" }, [
                        _c("div", { staticClass: "q-display-1 q-mb-md" }, [
                          _vm._v(_vm._s(_vm.selected_badge.title))
                        ]),
                        _c("p", [
                          _vm._v(_vm._s(_vm.selected_badge.description))
                        ]),
                        _vm.selected_badge.earned_date
                          ? _c("p", [
                              _vm._v(
                                _vm._s(_vm.$t("earned_in")) +
                                  ": " +
                                  _vm._s(
                                    _vm.formatDate(
                                      _vm.selected_badge.earned_date
                                    )
                                  )
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }